// extracted by mini-css-extract-plugin
export default {"section":"hA-z","inSectionButton":"iA-z","addressCard":"jA-z","disabled":"kA-z","cautionBox":"lA-z","failureBox":"mA-z","fade-out":"nA-z","successBox":"oA-z"};